const binding = { modules: {}, dataActions: {} };

    (binding.modules['millcraft-b2b'] = {
        c: () => require('partner/themes/millcraft-b2b/millcraft-b2b.tsx'),
        $type: 'themeModule',
        da: [],
        definitionExtensions: ['active-image','b2b-requests-status','business-organization-list','buybox','cart-icon','cart','checkout-customer-account-payment','checkout-payment-instrument','checkout-section-container','checkout','content-block','header','image-list','navigation-menu','order-confirmation','order-template-list','promo-banner','quickview','ratings-histogram','reviews-list','search-result-container','search','sign-in','store-selector','text-block','write-review'],
        iNM: false,
        ns: '__local__',
        n: 'millcraft-b2b',
        p: '__local__',
        
        pdp: '',
        
        themeSettings: 'millcraft-b2b.theme.settings.json',
        md: 'src/themes/millcraft-b2b'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };